module.exports = __webpack_public_path__ + "static/media/box-open.5c54d391.svg";